'use client';

import { skipToken, useInfiniteQuery } from '@tanstack/react-query';

import { Libraries, type LibraryListResponse } from '@air/api';
import { type LibraryListOptions, type Workspace } from '@air/api/types';

export const LIBRARIES_LIST_KEY = '@plugin-ui/LIBRARIES_LIST';

export const getLibrariesListKey = (params?: UseLibrariesListParams) => {
  return [LIBRARIES_LIST_KEY, params];
};

export type UseLibrariesListParams = LibraryListOptions & {
  workspaceId: Workspace['id'] | undefined;
};

export const useLibrariesList = (params: UseLibrariesListParams) => {
  const { workspaceId } = params;

  return useInfiniteQuery({
    getNextPageParam: (lastPage: LibraryListResponse) => lastPage?.pagination?.cursor,
    initialPageParam: '',
    queryFn: workspaceId
      ? ({ pageParam }) =>
          Libraries.list({
            ...params,
            cursor: pageParam || null,
            workspaceId,
          })
      : skipToken,
    queryKey: getLibrariesListKey(params),
  });
};
